"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
exports.__esModule = true;
exports.resolveTrackingPairs = exports.calculateMany = exports.calculate = exports.lenseRate = exports.lenseRateMap = exports.loadCountervalues = exports.initialState = exports.inferTrackingPairForAccounts = exports.importCountervalues = exports.exportCountervalues = void 0;
var logs_1 = require("@ledgerhq/logs");
var helpers_1 = require("../account/helpers");
var promise_1 = require("../promise");
var helpers_2 = require("./helpers");
var modules_1 = require("./modules");
// yield raw version of the countervalues state to be saved in a db
function exportCountervalues(_a) {
    var e_1, _b;
    var data = _a.data, status = _a.status;
    var out = {
        status: status
    };
    for (var path in data) {
        var obj = {};
        try {
            for (var _c = (e_1 = void 0, __values(data[path])), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2), k = _e[0], v = _e[1];
                obj[k] = v;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c["return"])) _b.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        out[path] = obj;
    }
    return out;
}
exports.exportCountervalues = exportCountervalues;
// restore a countervalues state from the raw version
function importCountervalues(_a, settings) {
    var status = _a.status, rest = __rest(_a, ["status"]);
    var data = {};
    for (var path in rest) {
        var obj = rest[path];
        var map = new Map();
        for (var k in obj) {
            map.set(k, obj[k]);
        }
        data[path] = map;
    }
    return {
        data: data,
        status: status,
        cache: Object.entries(data).reduce(function (prev, _a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], val = _c[1];
            return (__assign(__assign({}, prev), (_b = {}, _b[key] = generateCache(key, val, settings), _b)));
        }, {})
    };
}
exports.importCountervalues = importCountervalues;
// infer the tracking pair from user accounts to know which pairs are concerned
function inferTrackingPairForAccounts(accounts, countervalue) {
    var yearAgo = new Date();
    yearAgo.setFullYear(yearAgo.getFullYear() - 1);
    return resolveTrackingPairs((0, helpers_1.flattenAccounts)(accounts).map(function (a) {
        var currency = (0, helpers_1.getAccountCurrency)(a);
        return {
            from: currency,
            to: countervalue,
            startDate: a.creationDate < yearAgo ? a.creationDate : yearAgo
        };
    }));
}
exports.inferTrackingPairForAccounts = inferTrackingPairForAccounts;
exports.initialState = {
    data: {},
    status: {},
    cache: {}
};
var MAX_RETRY_DELAY = 7 * helpers_2.incrementPerGranularity.daily;
// synchronize all countervalues incrementally (async update of the countervalues state)
function loadCountervalues(state, settings) {
    return __awaiter(this, void 0, void 0, function () {
        var data, cache, status, nowDate, latestToFetch, histoToFetch, rateGranularities, _a, histo, latest, updates, changesKeys;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    data = __assign({}, state.data);
                    cache = __assign({}, state.cache);
                    status = __assign({}, state.status);
                    nowDate = new Date();
                    latestToFetch = settings.trackingPairs;
                    histoToFetch = [];
                    rateGranularities = ["daily", "hourly"];
                    rateGranularities.forEach(function (granularity) {
                        var format = helpers_2.formatPerGranularity[granularity];
                        var earliestHisto = format(nowDate);
                        (0, logs_1.log)("countervalues", "earliestHisto=" + earliestHisto);
                        var limit = helpers_2.datapointLimits[granularity];
                        settings.trackingPairs.forEach(function (_a) {
                            var from = _a.from, to = _a.to, startDate = _a.startDate;
                            var key = (0, helpers_2.pairId)({
                                from: from,
                                to: to
                            });
                            var c = cache[key];
                            var stats = c && c.stats;
                            var s = status[key];
                            // when there are too much http failures, slow down the rate to be actually re-fetched
                            if ((s === null || s === void 0 ? void 0 : s.failures) && s.timestamp) {
                                var failures = s.failures, timestamp = s.timestamp;
                                var secondsBetweenRetries = Math.min(Math.exp(failures * 0.5), MAX_RETRY_DELAY);
                                var nextTarget = timestamp + 1000 * secondsBetweenRetries;
                                if (nowDate.valueOf() < nextTarget) {
                                    (0, logs_1.log)("countervalues", "".concat(key, "@").concat(granularity, " discarded: too much HTTP failures (").concat(failures, ") retry in ~").concat(Math.round((nextTarget - nowDate.valueOf()) / 1000), "s"));
                                    return;
                                }
                            }
                            var start = startDate || nowDate;
                            var limitDate = Date.now() - limit;
                            if (limitDate && start.valueOf() < limitDate) {
                                start = new Date(limitDate);
                            }
                            var needOlderReload = s && s.oldestDateRequested && start < new Date(s.oldestDateRequested);
                            if (needOlderReload) {
                                (0, logs_1.log)("countervalues", "".concat(key, "@").concat(granularity, " need older reload (").concat(start.toISOString(), " < ").concat(String(s && s.oldestDateRequested), ")"));
                            }
                            if (!needOlderReload) {
                                // we do not miss datapoints in the past so we can ask the only remaining part
                                if (stats &&
                                    stats.earliestStableDate &&
                                    stats.earliestStableDate > start) {
                                    start = stats.earliestStableDate;
                                }
                            }
                            // nothing to fetch for historical
                            if (format(start) === earliestHisto)
                                return;
                            histoToFetch.push([
                                granularity,
                                {
                                    from: from,
                                    to: to,
                                    startDate: start
                                },
                                key,
                            ]);
                        });
                    });
                    (0, logs_1.log)("countervalues", "".concat(histoToFetch.length, " historical value to fetch (").concat(settings.trackingPairs.length, " pairs)"));
                    return [4 /*yield*/, Promise.all([
                            (0, promise_1.promiseAllBatched)(10, histoToFetch, function (_a) {
                                var _b = __read(_a, 3), granularity = _b[0], pair = _b[1], key = _b[2];
                                return (0, modules_1.fetchHistorical)(granularity, pair)
                                    .then(function (rates) {
                                    var _a;
                                    var _b;
                                    // Update status infos
                                    var id = (0, helpers_2.pairId)(pair);
                                    var oldestDateRequested = (_b = status[id]) === null || _b === void 0 ? void 0 : _b.oldestDateRequested;
                                    if (pair.startDate) {
                                        if (!oldestDateRequested ||
                                            pair.startDate < new Date(oldestDateRequested)) {
                                            oldestDateRequested = pair.startDate.toISOString();
                                        }
                                    }
                                    status[id] = {
                                        timestamp: Date.now(),
                                        oldestDateRequested: oldestDateRequested
                                    };
                                    return _a = {},
                                        _a[key] = rates,
                                        _a;
                                })["catch"](function (e) {
                                    // TODO work on the semantic of failure.
                                    // do we want to opt-in for the 404 cases and make other fails it all?
                                    // do we want to be resilient on individual pulling / keep error somewhere?
                                    var id = (0, helpers_2.pairId)(pair);
                                    // only on HTTP error, we count the failures (not network down case)
                                    if (e && typeof e.status === "number" && e.status) {
                                        var s = status[id];
                                        status[id] = {
                                            timestamp: Date.now(),
                                            failures: ((s === null || s === void 0 ? void 0 : s.failures) || 0) + 1,
                                            oldestDateRequested: s === null || s === void 0 ? void 0 : s.oldestDateRequested
                                        };
                                    }
                                    (0, logs_1.log)("countervalues-error", "Failed to fetch ".concat(granularity, " history for ").concat(pair.from.ticker, "-").concat(pair.to.ticker, " ").concat(String(e)));
                                    return null;
                                });
                            }),
                            (0, modules_1.fetchLatest)(latestToFetch)
                                .then(function (rates) {
                                var out = {};
                                var hasData = false;
                                latestToFetch.forEach(function (pair, i) {
                                    var _a;
                                    var key = (0, helpers_2.pairId)(pair);
                                    var latest = rates[i];
                                    if (((_a = data[key]) === null || _a === void 0 ? void 0 : _a.get("latest")) === latest)
                                        return;
                                    out[key] = {
                                        latest: rates[i]
                                    };
                                    hasData = true;
                                });
                                if (!hasData)
                                    return null;
                                return out;
                            })["catch"](function (e) {
                                (0, logs_1.log)("countervalues-error", "Failed to fetch latest for " +
                                    latestToFetch
                                        .map(function (p) { return "".concat(p.from.ticker, "-").concat(p.to.ticker); })
                                        .join(",") +
                                    " " +
                                    String(e));
                                return null;
                            }),
                        ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 2]), histo = _a[0], latest = _a[1];
                    updates = histo.concat(latest).filter(Boolean);
                    (0, logs_1.log)("countervalues", updates.length + " updates to apply");
                    changesKeys = {};
                    updates.forEach(function (patch) {
                        Object.keys(patch).forEach(function (key) {
                            changesKeys[key] = 1;
                            if (!data[key]) {
                                data[key] = new Map();
                            }
                            Object.entries(patch[key]).forEach(function (_a) {
                                var _b = __read(_a, 2), k = _b[0], v = _b[1];
                                if (typeof v === "number")
                                    data[key].set(k, v);
                            });
                        });
                    });
                    // synchronize the cache
                    Object.keys(changesKeys).forEach(function (pair) {
                        cache[pair] = generateCache(pair, data[pair], settings);
                    });
                    return [2 /*return*/, {
                            data: data,
                            cache: cache,
                            status: status
                        }];
            }
        });
    });
}
exports.loadCountervalues = loadCountervalues;
function lenseRateMap(state, pair) {
    if (!(0, modules_1.isCountervalueEnabled)(pair.from) || !(0, modules_1.isCountervalueEnabled)(pair.to)) {
        return;
    }
    var rateId = (0, helpers_2.pairId)(pair);
    return state.cache[rateId];
}
exports.lenseRateMap = lenseRateMap;
function lenseRate(_a, query) {
    var stats = _a.stats, fallback = _a.fallback, map = _a.map;
    var date = query.date;
    if (!date)
        return map.get("latest");
    var _b = (0, helpers_2.formatCounterValueHashes)(date), iso = _b.iso, hour = _b.hour, day = _b.day;
    if (stats.earliest && iso > stats.earliest)
        return map.get("latest");
    return map.get(hour) || map.get(day) || fallback;
}
exports.lenseRate = lenseRate;
function calculate(state, initialQuery) {
    var _a = (0, modules_1.aliasPair)({
        from: initialQuery.from,
        to: initialQuery.to
    }), from = _a.from, to = _a.to;
    if (from === to)
        return initialQuery.value;
    var date = initialQuery.date, value = initialQuery.value, disableRounding = initialQuery.disableRounding, reverse = initialQuery.reverse;
    var query = {
        date: date,
        from: from,
        to: to
    };
    var map = lenseRateMap(state, query);
    if (!map)
        return;
    var rate = lenseRate(map, query);
    if (!rate)
        return;
    var mult = reverse
        ? (0, helpers_2.magFromTo)(initialQuery.to, initialQuery.from)
        : (0, helpers_2.magFromTo)(initialQuery.from, initialQuery.to);
    rate = (0, modules_1.mapRate)(initialQuery, rate);
    if (reverse && rate) {
        rate = 1 / rate;
    }
    var val = rate ? value * rate * mult : 0;
    return disableRounding ? val : Math.round(val);
}
exports.calculate = calculate;
function calculateMany(state, dataPoints, initialQuery) {
    var reverse = initialQuery.reverse, disableRounding = initialQuery.disableRounding;
    var query = (0, modules_1.aliasPair)(initialQuery);
    var from = query.from, to = query.to;
    if (from === to)
        return dataPoints.map(function (d) { return d.value; });
    var map = lenseRateMap(state, query);
    if (!map)
        return Array(dataPoints.length).fill(undefined); // undefined array
    var mult = reverse
        ? (0, helpers_2.magFromTo)(initialQuery.to, initialQuery.from)
        : (0, helpers_2.magFromTo)(initialQuery.from, initialQuery.to);
    return dataPoints.map(function (_a) {
        var value = _a.value, date = _a.date;
        if (from === to)
            return value;
        var rate = lenseRate(map, {
            from: from,
            to: to,
            date: date
        });
        if (!rate)
            return;
        rate = (0, modules_1.mapRate)(initialQuery, rate);
        if (reverse && rate) {
            rate = 1 / rate;
        }
        var val = rate ? value * rate * mult : 0;
        return disableRounding ? val : Math.round(val);
    });
}
exports.calculateMany = calculateMany;
function generateCache(pair, rateMap, settings) {
    var map = new Map(rateMap);
    var sorted = Array.from(map.keys())
        .sort()
        .filter(function (k) { return k !== "latest"; });
    var oldest = sorted[0];
    var earliest = sorted[sorted.length - 1];
    var oldestDate = oldest ? (0, helpers_2.parseFormattedDate)(oldest) : null;
    var earliestDate = earliest ? (0, helpers_2.parseFormattedDate)(earliest) : null;
    var earliestStableDate = earliestDate;
    var fallback;
    var hasHole = false;
    if (oldestDate && oldest) {
        // we find the most recent stable day and we set it in earliestStableDate
        // if autofillGaps is on, shifting daily gaps (hourly don't need to be shifted as it automatically fallback on a day rate)
        var now = Date.now();
        var oldestTime = oldestDate.getTime();
        var shiftingValue = map.get(oldest) || 0;
        if (settings.autofillGaps) {
            fallback = shiftingValue;
        }
        for (var t = oldestTime; t < now; t += helpers_2.incrementPerGranularity.daily) {
            var d = new Date(t);
            var k = (0, helpers_2.formatCounterValueDay)(d);
            if (!map.has(k)) {
                if (!hasHole) {
                    hasHole = true;
                    earliestStableDate = d;
                }
                if (settings.autofillGaps) {
                    map.set(k, shiftingValue);
                }
            }
            else {
                if (settings.autofillGaps) {
                    shiftingValue = map.get(k) || 0;
                }
            }
        }
        if (!map.get("latest") && settings.autofillGaps) {
            map.set("latest", shiftingValue);
        }
    }
    else {
        if (settings.autofillGaps) {
            fallback = map.get("latest") || 0;
        }
    }
    var stats = {
        oldest: oldest,
        earliest: earliest,
        oldestDate: oldestDate,
        earliestDate: earliestDate,
        earliestStableDate: earliestStableDate
    };
    return {
        map: map,
        stats: stats,
        fallback: fallback
    };
}
// apply dedup & aliasing logics
function resolveTrackingPairs(pairs) {
    var d = {};
    pairs.map(function (p) {
        var _a = (0, modules_1.resolveTrackingPair)({
            from: p.from,
            to: p.to
        }), from = _a.from, to = _a.to;
        if (!(0, modules_1.isCountervalueEnabled)(from) || !(0, modules_1.isCountervalueEnabled)(to))
            return;
        if (from === to)
            return;
        // dedup and keep oldest date
        var date = p.startDate;
        var k = (0, helpers_2.pairId)(p);
        if (d[k]) {
            var startDate = d[k].startDate;
            if (startDate && date) {
                date = date < startDate ? date : startDate;
            }
        }
        d[k] = {
            from: from,
            to: to,
            startDate: date
        };
    });
    // $FlowFixMe -_-
    return Object.values(d);
}
exports.resolveTrackingPairs = resolveTrackingPairs;
//# sourceMappingURL=logic.js.map